
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/header';

const CompanyLoadingState = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center mb-4">
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={() => navigate('/companies')} 
        className="mr-2"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Companies
      </Button>
      <div className="animate-pulse">
        <div className="h-8 bg-gray-200 rounded w-1/4 mb-4"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-8"></div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 space-y-6">
            <div className="h-64 bg-gray-200 rounded"></div>
            <div className="h-64 bg-gray-200 rounded"></div>
          </div>
          <div className="space-y-6">
            <div className="h-40 bg-gray-200 rounded"></div>
            <div className="h-40 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyLoadingState;
